import React, { useRef } from "react";
import x1921 from "./images/x1921.png";
import containerIcon from "./images/container.svg";
import sectionMaskGroup from "./images/Logos.png";
import sectionMaskGroupMobile from "./images/Logos-3.png";
import brochureImg from "./images/merkazy_brochure.png";
import clock1 from "./images/clock-1.png";
import calendar1 from "./images/calendar-1.png";
import setting1 from "./images/setting-1.png";
import ux1 from "./images/ux-1.png";
import gps1 from "./images/gps-1.png";
import percent11 from "./images/percent-1-1.png";
// import inHotel from "./images/frame-bg.jpg";
import inHotel from "./images/hotel-helm.png"; 
import FormSection from "./components/FormSection";

export const App = () => {
  const footerRef = useRef<HTMLElement>(null);

  const scrollToFooter = () => {
    if (footerRef.current) {
      const headerOffset = 80;
      const elementPosition =
        footerRef.current.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerOffset;
      window.scrollTo({ top: offsetPosition, behavior: "smooth" });
    }
  };

  return (
    <div className="bg-white">
      {/* Header */}
      <header className="w-full py-4 border-b border-gray-200">
        <div className="container mx-auto px-4 md:px-6 flex items-center justify-center md:justify-between">
          {/* Logo */}
          <a href="https://merakzy.com" target="_blank" rel="noopener noreferrer">
              <img
                src={x1921}
                alt="Merakzy Logo"
                className="w-40 h-auto cursor-pointer"
              />
            </a>
          {/* Button — hidden on small screens, visible on md and larger */}
          <button
            onClick={scrollToFooter}
            className="hidden md:flex items-center gap-2 bg-[#fa0053] text-white font-bold rounded-full px-6 py-3 hover:opacity-90 transition"
          >
            <span>Registruj se sada</span>
            <img src={containerIcon} alt="" className="w-5 h-5" />
          </button>
        </div>
      </header>

      {/* Partner Heading */}
      <section className="text-center pt-24 px-4 md:px-6">
        <div className="container mx-auto">
          <h1 className="text-4xl md:text-6xl font-semibold leading-tight mb-6">
            <span className="text-[#0c0407]">Automatizujte </span>
            <span className="text-[#c4c4c4]">svoju agenciju</span>
            <span className="text-[#0c0407] block">uz Merakzy</span>
          </h1>
          <p className="text-lg md:text-xl text-[#0c0407] max-w-3xl mx-auto mt-4">
            Saznajte kako Merakzy donosi tehnologiju Booking.com-a u svakodnevno
            poslovanje turističkih agencija i zašto postaje novi standard
            turističkog poslovanja u regionu.
          </p>
          <button
            onClick={scrollToFooter}
            className="mt-8 flex items-center justify-center gap-2 bg-[#fa0053] text-white font-bold rounded-full px-6 py-3 mx-auto hover:opacity-90 transition"
          >
            Registruj se sada
            <img src={containerIcon} alt="" className="w-5 h-5" />
            
          </button>
        </div>
      </section>

      {/* Brochure Section */}
      <section className="relative w-full pb-12 md:pb-16 px-4 md:px-6">
        <div className="container mx-auto">
          <div className="relative w-full h-[20rem] md:h-[60rem] rounded-3xl overflow-hidden">
            {/* Brochure image as full width background */}
            <img
              src={brochureImg}
              alt="Brochure"
              className="w-full h-full object-contain rounded-3xl"
            />
          </div>
        </div>
      </section>

      {/* Partners Logos */}
      <section className="pb-16 border-b border-gray-200 px-4 md:px-6">
        <div className="container mx-auto text-center">
          <p className="text-gray-400 font-bold mb-6">
            SOFTVER VEĆ KORISTE TURISTIČKE AGENCIJE IZ MAKEDONIJE I SRBIJE
          </p>
          {/* <img src={sectionMaskGroup} alt="Partner logos" className="mx-auto max-w-full h-auto" /> */}

          <img
            src={sectionMaskGroupMobile}
            alt="Partner logos"
            className="block md:hidden mx-auto max-w-full h-auto"
          />

          {/* Desktop / larger screens image */}
          <img
            src={sectionMaskGroup}
            alt="Partner logos"
            className="hidden md:block mx-auto max-w-full h-auto"
          />
        </div>
      </section>

      {/* Hero Section */}
      <section className="relative bg-white py-16 md:py-24 px-4 md:px-6">
        <div className="container mx-auto flex flex-col lg:flex-row items-center gap-12">
          <div
            className="w-full lg:w-1/2 h-64 md:h-96 rounded-3xl bg-cover bg-center"
            style={{ backgroundImage: `url(${inHotel})` }}
            aria-label="Event promotional image"
          />
          <div className="w-full lg:w-1/2 flex flex-col gap-4 text-left">
            <div className="flex items-center gap-2">
              <div className="w-6 h-6 flex items-center justify-center bg-[#fa0053] rounded-full">
                <img src={clock1} alt="Clock icon" className="w-4 h-4" />
              </div>
              <span className="font-semibold text-sm">GDE I KADA</span>
            </div>
            <h2 className="text-2xl md:text-4xl font-semibold leading-tight">
              Pozivamo vas na događaj za menadžere i vlasnike turističkih agencija
            </h2>
            <p className="text-gray-800 text-base md:text-lg leading-relaxed">
              Dođite da se upoznamo. Pokazaćemo vam kako uz jedan softver možete
              automatizovati poslovanje i ostaviti utisak kod klijenata kao Booking.com.
            </p>
            <time className="text-2xl md:text-3xl font-semibold">
              19 novembar, 2025
            </time>
            <div className="flex flex-col sm:flex-row sm:gap-8 text-gray-800 font-semibold">
              <div>
                <span className="text-gray-400 block">Lokacija:</span> Hotel Helm, Niš
              </div>
              <div>
                <span className="text-gray-400 block">Vreme:</span> 11:00 časova
              </div>
            </div>
            <button
              onClick={scrollToFooter}
              className="mt-4 w-full sm:w-[200px] flex items-center justify-center gap-2 bg-[#fa0053] text-white font-bold rounded-full py-3 hover:opacity-90 transition"
            >
              Registruj se sada
              <img src={containerIcon} alt="" className="w-5 h-5" />
            </button>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="bg-white pb-24 px-4 md:px-6">
        <div className="container mx-auto">
          <div className="text-left md:text-center mb-12">
            <div className="flex items-center md:justify-center gap-2 mb-6">
              <div className="w-6 h-6 flex items-center justify-center bg-[#fa0053] rounded-full">
                <img src={calendar1} alt="" className="w-4 h-4" />
              </div>
              <span className="font-semibold text-sm">NOVI POČETAK</span>
            </div>

            <h2 className="text-3xl md:text-5xl font-semibold mb-6">
              Zašto vredi doći?
            </h2>

            <p className="text-lg md:text-xl text-gray-800">
              Zato što je ovaj događaj prava prilika da vidite šta sledi u turizmu. <br />
              Od realnih primera do novih tehnologija i ideja koje će vam uštedeti
              vreme i doneti više klijenata.
            </p>
          </div>

          {/* Service cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: setting1, title: "Automatizacija bez haosa", description: "Pratite rezervacije, uplate i agente u realnom vremenu.", bgColor: "border border-gray-200", iconBg: "bg-[#fa0053]", textColor: "text-black" },
              { icon: ux1, title: "UX kao Booking.com", description: "Dajte svojoj agenciji digitalni izgled koji putnici već prepoznaju i vole.", bgColor: "border border-gray-200", iconBg: "bg-[#fa0053]", textColor: "text-black" },
              { icon: gps1, title: "Regionalna mreža subagenata", description: "Omogućite subagentima iz različitih zemalja da prodaju vaše aranžmane i povećajte svoju vidljivost.", bgColor: "border border-gray-200", iconBg: "bg-[#fa0053]", textColor: "text-black" },
              { icon: percent11, title: "Zaradite ili koristite besplatno!", description: "Saznajte kako da dobijete softver bez troškova i da stvorite dodatni prihod.", bgColor: "bg-gradient-to-r from-[#FA0053] to-[#B6003C]", iconBg: "bg-white", textColor: "text-white" },
            ].map((card, i) => (
              <div key={i} className={`p-6 rounded-3xl flex flex-col gap-4 ${card.bgColor}`}>
                <div className={`w-12 h-12 flex items-center justify-center rounded-full ${card.iconBg}`}>
                  <img src={card.icon} alt="" className="w-6 h-6" />
                </div>
                <h3 className={`font-semibold ${card.textColor} text-xl`}>{card.title}</h3>
                <p className={`${card.textColor} text-base`}>{card.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FormSection />

      {/* Footer */}
      <footer
        ref={footerRef}
        className="bg-white py-6 text-center text-gray-800 font-semibold text-sm"
      >
        © 2025 Merakzy. All rights reserved.
      </footer>
    </div>
  );
};

export default App;